/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/



/*!
 * accounting.js v0.4.2, copyright 2014 Open Exchange Rates, MIT license, http://openexchangerates.github.io/accounting.js
 */
(function(p,z){function q(a){return!!(""===a||a&&a.charCodeAt&&a.substr)}function m(a){return u?u(a):"[object Array]"===v.call(a)}function r(a){return"[object Object]"===v.call(a)}function s(a,b){var d,a=a||{},b=b||{};for(d in b)b.hasOwnProperty(d)&&null==a[d]&&(a[d]=b[d]);return a}function j(a,b,d){var c=[],e,h;if(!a)return c;if(w&&a.map===w)return a.map(b,d);for(e=0,h=a.length;e<h;e++)c[e]=b.call(d,a[e],e,a);return c}function n(a,b){a=Math.round(Math.abs(a));return isNaN(a)?b:a}function x(a){var b=c.settings.currency.format;"function"===typeof a&&(a=a());return q(a)&&a.match("%v")?{pos:a,neg:a.replace("-","").replace("%v","-%v"),zero:a}:!a||!a.pos||!a.pos.match("%v")?!q(b)?b:c.settings.currency.format={pos:b,neg:b.replace("%v","-%v"),zero:b}:a}var c={version:"0.4.1",settings:{currency:{symbol:"$",format:"%s%v",decimal:".",thousand:",",precision:2,grouping:3},number:{precision:0,grouping:3,thousand:",",decimal:"."}}},w=Array.prototype.map,u=Array.isArray,v=Object.prototype.toString,o=c.unformat=c.parse=function(a,b){if(m(a))return j(a,function(a){return o(a,b)});a=a||0;if("number"===typeof a)return a;var b=b||".",c=RegExp("[^0-9-"+b+"]",["g"]),c=parseFloat((""+a).replace(/\((.*)\)/,"-$1").replace(c,"").replace(b,"."));return!isNaN(c)?c:0},y=c.toFixed=function(a,b){var b=n(b,c.settings.number.precision),d=Math.pow(10,b);return(Math.round(c.unformat(a)*d)/d).toFixed(b)},t=c.formatNumber=c.format=function(a,b,d,i){if(m(a))return j(a,function(a){return t(a,b,d,i)});var a=o(a),e=s(r(b)?b:{precision:b,thousand:d,decimal:i},c.settings.number),h=n(e.precision),f=0>a?"-":"",g=parseInt(y(Math.abs(a||0),h),10)+"",l=3<g.length?g.length%3:0;return f+(l?g.substr(0,l)+e.thousand:"")+g.substr(l).replace(/(\d{3})(?=\d)/g,"$1"+e.thousand)+(h?e.decimal+y(Math.abs(a),h).split(".")[1]:"")},A=c.formatMoney=function(a,b,d,i,e,h){if(m(a))return j(a,function(a){return A(a,b,d,i,e,h)});var a=o(a),f=s(r(b)?b:{symbol:b,precision:d,thousand:i,decimal:e,format:h},c.settings.currency),g=x(f.format);return(0<a?g.pos:0>a?g.neg:g.zero).replace("%s",f.symbol).replace("%v",t(Math.abs(a),n(f.precision),f.thousand,f.decimal))};c.formatColumn=function(a,b,d,i,e,h){if(!a)return[];var f=s(r(b)?b:{symbol:b,precision:d,thousand:i,decimal:e,format:h},c.settings.currency),g=x(f.format),l=g.pos.indexOf("%s")<g.pos.indexOf("%v")?!0:!1,k=0,a=j(a,function(a){if(m(a))return c.formatColumn(a,f);a=o(a);a=(0<a?g.pos:0>a?g.neg:g.zero).replace("%s",f.symbol).replace("%v",t(Math.abs(a),n(f.precision),f.thousand,f.decimal));if(a.length>k)k=a.length;return a});return j(a,function(a){return q(a)&&a.length<k?l?a.replace(f.symbol,f.symbol+Array(k-a.length+1).join(" ")):Array(k-a.length+1).join(" ")+a:a})};if("undefined"!==typeof exports){if("undefined"!==typeof module&&module.exports)exports=module.exports=c;exports.accounting=c}else"function"===typeof define&&define.amd?define([],function(){return c}):(c.noConflict=function(a){return function(){p.accounting=a;c.noConflict=z;return c}}(p.accounting),p.accounting=c)})(this);




// Auto Animate Homepage Slider - Narrative Theme

jQuery(function(){
  
  	var clicked = false;
  
  	var clickedAt = null;
  
	jQuery('.slideshow__button--previous').on('click', function() {
		clickedAt = Date.now();
        clicked = true;
    	_transition('prev')
    });
    jQuery('.slideshow__button--next').on('click', function() {
	  clickedAt = Date.now();
      clicked = true;
      _transition('next')
    });

    setTimeout(function() {

    autoplay();
     

    }, 7000);
    
  
  var autoplay = function() {
  	if(clicked == true) { 
        clicked = false;
        var interval = 3000;
        
        if(clickedAt != null) {
           interval = Date.now()-clickedAt;
        }
        clickedAt = null;
        setTimeout(function() {    
      		autoplay(); 
      	}, interval);        
      } else {
        _transition('next');
        setTimeout(function() {    
      		autoplay(); 
      	}, 7000);
      }
  }
  
  
    
    var _transition = function(direction) {
	var $slide = $('.slideshow__slide--active')
                   .removeClass('slideshow__slide--active');

    var $slides = $('.slideshow__slide');
  
  if (direction == "prev") {
    var index = $slides.index($slide);
  
    if (index == 0) {
      var currentIndex = $slides.length - 1;
    } else {
      var currentIndex = (index - 1);
    }
  
  } else {

    var currentIndex = ($slides.index($slide) + 1) % $slides.length;

  }
//     jQuery('.slideshow__heading').css('font-size', '18px');
    $slides
      .eq(currentIndex)
      .addClass('slideshow__slide--active');	
  };
  
  

  
  
  
  
  
  
  
  // Update Savings Prop and Bed Details
  
  
  //var $container = jQuery("#s-c1e4b85a-4357-4189-8e4f-23c36f3b1f2a");
  //var $container = jQuery("#s-090bafb3-c345-4ec1-8736-686d7336e3b1");
  	var $container = jQuery("#s-e9402ca0-433b-4d8c-a17b-17c275f8fef9");
  


  if ($container.length > 0) {

      var prevQuery = window.location.search;

      var financingPrices = { 
          "Twin": 44.00,
          "Twin XL": 47.00,
          "Full": 49.00,
          "Queen": 61.00,
          "King": 77.00,
          "Cal King": 83.00
      };

    
    
      var updateHardnessText = function() {
        
            var hardnessText = {
                "Firm Sleeper": "Created for back and stomach sleepers and anyone with lumbar pain. This bed feels firm but never stiff. It’s a comfort level that only comes with our quality components.",
                "Luxury Firm Multi-Sleeper": "Created for side sleepers that like a slightly firmer feel and enjoy a balance in terms of pushback, hug and contour. Also ideal for back and stomach sleepers that may roll over in the night and like a layer of softness with their support.",
                "Plush Multi-Sleeper": "Created for side sleepers and those seeking to ease hip, shoulder and joint pain. This bed offers an ideal blend of soothing comfort, support and temperature relief."
            };
      
      		var hardnessTitle = {
              	"Firm Sleeper": "The Luft Bed: Firm Sleeper",
              	"Luxury Firm Multi-Sleeper": "The Luft Bed: Luxury Firm Multi-Sleeper",
              	"Plush Multi-Sleeper": "The Luft Bed: Plush Multi-Sleeper"
            };
      
		//  var $hardnessSelect = jQuery("#Shg-Product-Option-option1-s-99e26338-bb50-46fd-8fcc-0a838f104c85"),
            var $hardnessSelect = jQuery("#Shg-Product-Option-option1-s-8e6bc6a5-630a-43c3-99d9-51266538726b"),
                hardnessKey = $hardnessSelect.val();
	
            jQuery(".comfortText span").text(hardnessText[hardnessKey]); 
			jQuery(".luftTitle h1 b").get(0).innerHTML = hardnessTitle[hardnessKey];

      
        };
    
    
    
    
    
    
    
    
    
    
    
      function getProductComparePrice() {
          var str = jQuery(".shg-product-compare-price").text();
          return launder(str);
      }

      function getProductPrice() {
          var str = jQuery(".shg-product-price").text();
          return launder(str);
      }

      function launder(str) {
          return parseFloat(str.replace("$", "").replace(",", ""), 10);
      }

      function updatePricing() {        
          var savings = getProductComparePrice() - getProductPrice();
          $container.find(".shg-product-compare-savings").remove();
          $container.append('<span class="shg-product-compare-savings">'+accounting.formatMoney(savings)+'</span>');
          jQuery(".shg-product-compare-price").data("savings", accounting.formatMoney(savings));

          // var selectedSize = jQuery("#Shg-Product-Option-option2-s-99e26338-bb50-46fd-8fcc-0a838f104c85").val();
          var selectedSize = jQuery("#Shg-Product-Option-option2-s-8e6bc6a5-630a-43c3-99d9-51266538726b").val();
          var price = financingPrices[selectedSize];
          if (price) {
              jQuery("#monthlyPymtAmount").text(accounting.formatMoney(price));   
          }
      }

      function urlChanged() {
          updatePricing();
          updateHardnessText();
      }

      function checkUrl() {

          if (prevQuery != window.location.search) {
              prevQuery = window.location.search;
              urlChanged();
          }

      }

      setInterval(checkUrl, 500);

      setTimeout(urlChanged, 1000);
      
    
  }
  
  
  
})






    
   

// END HP Slider


